import type { EventDetails } from "@/modules/events/types/eventDetailsApi"
import type { FunctionComponent } from "react"

import { useParams } from "next/navigation"

import { BuildingSkyscraper } from "@jobteaser/spark/components/Icons/BuildingSkyscraper"
import { Link } from "@jobteaser/spark/components/Link"
import { Text } from "@jobteaser/spark/components/Text"

import { useEventDetailsData } from "@/modules/events/hooks/useEventDetailsData"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./Companies.module.css"
import mainStyles from "./MainDetails.module.css"

export const Companies: FunctionComponent = () => {
  const { t } = useTranslation(["shared_action", "event_details"])
  const { eventSlug } = useParams<{ eventSlug: string }>()
  const event = useEventDetailsData(eventSlug)

  const { companies } = event as EventDetails
  const counter = companies?.length

  if (!counter) return null

  return (
    <div className={mainStyles.flexContainer} data-testid="event-details-main-details-companies">
      <BuildingSkyscraper className={mainStyles.icon} data-testid="event-details-main-details-companies-icon" />
      <div>
        <Text as="span" variant="body1" weight="bold" data-testid="event-details-main-details-companies-text">
          {t("event_details.about.companies", { count: counter })}
        </Text>
        <Link
          className={styles.seeAllLink}
          as="a"
          variant="body1"
          href="#companies"
          data-testid="event-details-main-details-companies-link"
        >
          {counter > 1 ? t("shared_action.see_all") : t("event_details.about.see")}
        </Link>
      </div>
    </div>
  )
}
